module.exports = __webpack_public_path__ + "img/43.cb11ff09.jpg";